import React from 'react';
import { ArtDecoFrame } from './ArtDecoFrame';
import { SuitDivider } from './SuitDivider';
import { SectionReveal } from './SectionReveal';
export function Antechamber() {
  return <section className="relative bg-felt felt-texture py-24 md:py-32" data-id="element-9">
      <div className="max-w-6xl mx-auto px-6" data-id="element-10">
        <SectionReveal data-id="element-11">
          {/* Section header */}
          <div className="text-center mb-16" data-id="element-12">
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-goldenrod uppercase tracking-[0.3em] mb-4" data-id="element-13">
              The Antechamber
            </h2>
            <p className="font-body text-goldenrod/70 italic text-lg tracking-wide" data-id="element-14">
              Counterfactual Chambers
            </p>
            <SuitDivider className="mt-8 max-w-md mx-auto" data-id="element-15" />
          </div>

          {/* Content in art deco frame */}
          <div className="max-w-3xl mx-auto" data-id="element-16">
            <ArtDecoFrame variant="full" data-id="element-17">
              <div className="text-center space-y-6" data-id="element-18">
                <p className="font-body text-ivory/90 text-lg md:text-xl leading-relaxed" data-id="element-19">
                  Strategame builds AI systems that master imperfect-information
                  games through advanced computational game theory. We operate
                  at the frontier where artificial intelligence meets strategic
                  decision-making under uncertainty.
                </p>
                <div className="text-goldenrod/50 text-sm tracking-[0.5em] select-none" aria-hidden="true" data-id="element-20">
                  ♠ ♦
                </div>
                <p className="font-body text-ivory/90 text-lg md:text-xl leading-relaxed" data-id="element-21">
                  Based in Limassol, Cyprus, we develop next-generation strategy
                  engines for poker and casino environments — systems that don't
                  merely calculate, but learn, adapt, and evolve against any
                  opponent.
                </p>
              </div>
            </ArtDecoFrame>
          </div>
        </SectionReveal>
      </div>
    </section>;
}